import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepInputContentContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    maxWidth: '480px',
  },
}));
